import {Component, Output, Input, EventEmitter, OnInit, OnDestroy, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'app-popup',
  templateUrl: './popup.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopupComponent implements OnInit, OnDestroy {
  @Input() canCollapse: boolean;
  @Input() showCross: boolean;
  @Output() notify: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {
    this.changeZIndex();
  }

  onCloseItem(): void {
    this.closeModal.emit();
  }

  ngOnDestroy(): void {
    this.changeZIndex(true);
  }

  changeZIndex(close?: boolean): void {
    const element = document.getElementsByTagName('app-navigation')[0];
    close ? element.classList.remove('change-index') : element.classList.add('change-index');
  }
}
